(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rubik-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCollectionPanels = () => {
      if (!window.matchMedia('(max-width: 989px)').matches) return;
      document.querySelectorAll('.rcol__filters').forEach((panel) => {
        if (panel.dataset.mobileReady === 'true') return;
        panel.open = false;
        panel.dataset.mobileReady = 'true';
      });
    };

    const initializeInfiniteCollection = () => {
      const root = document.querySelector('[data-rcol-infinite]');
      if (!root || root.dataset.initialized === 'true') return;

      const grid = root.closest('.rcol__results')?.querySelector('.rcol__grid');
      const loader = root.querySelector('[data-rcol-loader]');
      let nextLink = root.querySelector('[data-rcol-next]');
      if (!grid || !nextLink) return;

      root.dataset.initialized = 'true';
      let loading = false;

      const observer = new IntersectionObserver(async (entries) => {
        if (!entries.some((entry) => entry.isIntersecting) || loading || !nextLink) return;
        loading = true;
        const currentUrl = nextLink.href;
        nextLink.hidden = true;
        if (loader) loader.hidden = false;

        try {
          const response = await fetch(currentUrl, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(String(response.status));

          const html = await response.text();
          const page = new DOMParser().parseFromString(html, 'text/html');
          const incomingGrid = page.querySelector('.rcol__grid');
          const incomingNext = page.querySelector('[data-rcol-next]');

          if (!incomingGrid) throw new Error('missing-grid');
          const fragment = document.createDocumentFragment();
          Array.from(incomingGrid.children).forEach((card) => fragment.appendChild(card));
          grid.appendChild(fragment);

          if (incomingNext) {
            nextLink.href = incomingNext.href;
            nextLink.hidden = false;
          } else {
            observer.disconnect();
            nextLink.remove();
            nextLink = null;
            root.textContent = root.dataset.completeLabel;
          }
        } catch (error) {
          nextLink.hidden = false;
        } finally {
          if (loader) loader.hidden = true;
          loading = false;
        }
      }, { rootMargin: '500px 0px' });

      root.dataset.completeLabel = root.querySelector('.rcol__complete')?.textContent || 'Tous les produits sont affichés';
      observer.observe(root);
    };

    initializeCollectionPanels();
    initializeInfiniteCollection();
    document.addEventListener('shopify:section:load', () => {
      initializeCollectionPanels();
      initializeInfiniteCollection();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rubik-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let favicon = document.querySelector('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.type = 'image/svg+xml';
    favicon.href = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 64 64%22%3E%3Crect width=%2264%22 height=%2264%22 rx=%2215%22 fill=%22%23111319%22/%3E%3Cg transform=%22rotate(-7 32 32)%22%3E%3Crect x=%2210%22 y=%2210%22 width=%2244%22 height=%2244%22 rx=%2210%22 fill=%22none%22 stroke=%22white%22 stroke-width=%224%22/%3E%3Crect x=%2216%22 y=%2216%22 width=%2213%22 height=%2213%22 rx=%223%22 fill=%22%23ffd84d%22/%3E%3Crect x=%2235%22 y=%2216%22 width=%2213%22 height=%2213%22 rx=%223%22 fill=%22%23e6503d%22/%3E%3Crect x=%2216%22 y=%2235%22 width=%2213%22 height=%2213%22 rx=%223%22 fill=%22%233887f6%22/%3E%3Crect x=%2235%22 y=%2235%22 width=%2213%22 height=%2213%22 rx=%223%22 fill=%22%2349b675%22/%3E%3C/g%3E%3C/svg%3E';
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rubik-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rp-section]').forEach((section) => {
    const mainImage = section.querySelector('#RpMainImage');
    const variantSelect = section.querySelector('[data-rp-variant]');
    const price = section.querySelector('[data-rp-price]');
    const compare = section.querySelector('[data-rp-compare]');
    const mobilePrice = section.querySelector('[data-rp-mobile-price]');
    const addButton = section.querySelector('[data-rp-add]');
    const buyNowButton = section.querySelector('[data-rp-buy-now]');
    const stickyCart = section.querySelector('[data-rp-sticky-cart]');
    const stickyBuy = section.querySelector('[data-rp-sticky-buy]');
    const buyRow = section.querySelector('.rp__buy-row');
    const mobileSubmit = section.querySelector('[data-rp-mobile-submit]');
    const quantityInput = section.querySelector('[data-rp-quantity]');
    const form = section.querySelector('.rp__form');
    const currency = section.dataset.rpCurrency || 'EUR';
    const formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency });

    const setMainImage = (src, alt = '') => {
      if (!mainImage || !src) return;

      // Remove the initial responsive sources so the browser renders the
      // newly selected variant or gallery image instead of the first image.
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = src;
      mainImage.alt = alt;
    };

    const updateBundlePrices = (priceCents) => {
      section.querySelectorAll('[data-rp-bundle-total]').forEach((total) => {
        const quantity = Number(total.dataset.rpBundleTotal || 1);
        const discount = Number(total.dataset.rpBundleDiscount || 0);
        const totalCents = discount > 0
          ? Math.round((priceCents * quantity) - (priceCents * discount / 100))
          : priceCents * quantity;
        total.textContent = formatter.format(totalCents / 100);
      });
      section.querySelectorAll('[data-rp-bundle-regular]').forEach((regular) => {
        regular.textContent = formatter.format((priceCents * Number(regular.dataset.rpBundleRegular || 1)) / 100);
      });
      section.querySelectorAll('[data-rp-bundle-saving]').forEach((saving) => {
        const discount = Number(saving.dataset.rpBundleSaving || 0);
        saving.textContent = `${section.dataset.rpSavingPrefix || 'Économisez'} ${formatter.format(Math.round(priceCents * discount / 100) / 100)}`;
      });
    };

    updateBundlePrices(Number(section.dataset.rpPriceCents || 0));

    section.querySelectorAll('[data-rp-bundle]').forEach((bundle) => {
      bundle.addEventListener('change', () => {
        if (bundle.checked && quantityInput) quantityInput.value = bundle.dataset.quantity || '1';
      });
    });

    section.querySelectorAll('[data-rp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setMainImage(thumb.dataset.src, thumb.dataset.alt || '');
        section.querySelectorAll('[data-rp-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price;
        if (mobilePrice) mobilePrice.textContent = option.dataset.price;
        updateBundlePrices(Number(option.dataset.priceCents || 0));
        if (compare) {
          compare.textContent = option.dataset.compare;
          compare.hidden = option.dataset.discount !== 'true';
        }
        setMainImage(option.dataset.image, option.dataset.alt || '');
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
        }
        if (buyNowButton) buyNowButton.disabled = !available;
        if (mobileSubmit) mobileSubmit.disabled = !available;
        if (stickyBuy) stickyBuy.disabled = !available;
      });
    }

    if (buyNowButton && form) {
      buyNowButton.addEventListener('click', async () => {
        const root = window.Shopify?.routes?.root || '/';
        buyNowButton.disabled = true;
        buyNowButton.textContent = buyNowButton.dataset.loadingLabel;

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('cart_add_failed');
          window.location.assign(`${root}checkout`);
        } catch {
          buyNowButton.disabled = false;
          buyNowButton.textContent = buyNowButton.dataset.errorLabel;
          window.setTimeout(() => {
            buyNowButton.textContent = buyNowButton.dataset.label;
          }, 1800);
        }
      });
    }

    if (mobileSubmit && form) mobileSubmit.addEventListener('click', () => form.requestSubmit());
    if (stickyBuy && buyNowButton) stickyBuy.addEventListener('click', () => buyNowButton.click());
    if (stickyCart) {
      const updateStickyCart = () => {
        const showSticky = window.scrollY > 220;
        stickyCart.classList.toggle('is-visible', showSticky);
        stickyCart.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
      };
      window.addEventListener('scroll', updateStickyCart, { passive: true });
      updateStickyCart();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
